import { Dialog } from 'alurkerja-ui';
import moment from 'moment';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { MdCloudDownload } from 'react-icons/md';
import { downloadFile } from '@/utils/libs/fileUtil';
import { ProjectService } from '@/api/project';
import { ExtendedTableLowCodeRef } from '@/components/shared/table/ExtendedTableLowCode';

type ExportProjectProps = {
  tableRef: React.RefObject<ExtendedTableLowCodeRef>;
};

export const ExportProject: React.FC<ExportProjectProps> = ({ tableRef }) => {
  const { mutate: exportMutate, isPending: isExportLoading } =
    ProjectService.useExport();

  const exportAction = () => {
    const filters = tableRef.current?.getFilter();
    const sort = tableRef.current?.getSort();
    const orderBy = tableRef.current?.getOrderBy();

    exportMutate(
      { filters, sort, orderBy },
      {
        onSuccess: (response) => {
          Dialog.success({
            title: 'Success',
            description: 'Project list has been exported',
          });

          downloadFile(response, `Projects_${moment().format('YYYYMMDD')}.xlsx`);
        },
        onError: () => {
          Dialog.error({
            title: 'Error',
            description: 'Failed to export project list',
          });
        },
      },
    );
  };

  return (
    <OutlineButton
      icon={<MdCloudDownload />}
      onClick={exportAction}
      isLoading={isExportLoading}
    >
      Export
    </OutlineButton>
  );
};
